// eslint-disable-next-line import/prefer-default-export
export const API_URL = process.env.REACT_APP_API_URL || "https://api.sat.maartje.dev";
if (window.location.href.indexOf("www.tmsat.be") > -1) {
    console.log = () => { };
}